module.exports = __webpack_public_path__ + "img/icon_sec2_07.e8cb6e41.png";